import { ChevronRight } from "lucide-react"
import { TONE_COLORS } from "../tokens"

export const KpiTile = ({
  label,
  value,
  hint,
  icon,
  iconTone,
  emphasis = false,
  danger = false,
  active,
  onClick,
  compactValue = false,
  className = "",
}) => {
  const Tag = onClick ? "button" : "div"
  const tone = iconTone && TONE_COLORS[iconTone]
  return (
    <Tag
      className={`ds-kpi${emphasis ? " is-emphasis" : ""}${danger ? " is-danger" : ""}${active ? " is-active" : ""}${className ? ` ${className}` : ""}`}
      type={onClick ? "button" : undefined}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      aria-pressed={onClick && active !== undefined ? !!active : undefined}
    >
      {icon && (
        <span
          className="ds-kpi-icon"
          style={tone ? { background: tone.bg, color: tone.fg } : undefined}
        >
          {icon}
        </span>
      )}
      <div className="ds-kpi-body">
        <div className="ds-kpi-row">
          <div>
            <div className="ds-kpi-label">{label}</div>
            <div className="ds-kpi-value" style={compactValue ? { fontSize: 18 } : undefined}>
              {value}
            </div>
          </div>
          {onClick && (
            <span className="ds-kpi-chevron">
              <ChevronRight aria-hidden />
            </span>
          )}
        </div>
        {hint ? <div className="ds-kpi-hint">{hint}</div> : null}
      </div>
    </Tag>
  )
}

export const KpiStrip = ({ children }) => <div className="ds-kpi-strip">{children}</div>

export default KpiTile
